import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=c75c9124&scoped=true"
import script from "./Favorite.vue?vue&type=script&lang=js"
export * from "./Favorite.vue?vue&type=script&lang=js"
import style0 from "./Favorite.vue?vue&type=style&index=0&id=c75c9124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75c9124",
  null
  
)

export default component.exports